import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import { visibilitySettings } from '../../../utils';
import BackstageRowColumns from '../../BackstageRowColumns';
import BackstageRowGrid from '../../BackstageRowGrid';

const integrationData = {
  contentSection: BackstageConstants.BackstageSections.SIMILAR_ARTISTS,
};
const SimilarArtistsWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageConstants.BackstageSections.SIMILAR_ARTISTS },
  visibilitySettings({ isRowComponent: true, useMemo: true }),
)(BackstageRowGrid);

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const ArtistSimilarArtists = props => {
  const { similarArtists } = props;
  if (similarArtists.size <= 0) return null;

  return (
    <D.ContentSection
      isSimilarArtists={true}
      title={<FormattedMessage {...BackstageConstants.messages.fansAlsoLike} />}
    >
      <D.AppContextIntegrationData data={integrationData}>
        {/* @ts-expect-error TS(2559) FIXME: Type '{ children: any; }' has no properties in com... Remove this comment to see the full error message */}
        <SimilarArtistsWithLogger>
          {/* @ts-expect-error TS(7006) FIXME: Parameter 'pandoraId' implicitly has an 'any' type... Remove this comment to see the full error message */}
          {similarArtists.map(pandoraId => (
            <BackstageRowColumns pandoraId={pandoraId} key={pandoraId} />
          ))}
        </SimilarArtistsWithLogger>
      </D.AppContextIntegrationData>
    </D.ContentSection>
  );
};

ArtistSimilarArtists.propTypes = {
  similarArtists: ImmutablePropTypes.listOf(PropTypes.string),
};

export default ArtistSimilarArtists;
